import React from "react";

const Setting: React.FC = () => {
  return <h1>Setting Page</h1>;
};

export default Setting;
